import { Roles } from '@/auth/azure/Roles'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import HourEditorForm from '@/routes/hours/HourEditor.form'
import { hourEditorRouteLoader } from '@/routes/hours/HourEditor.route'
import { HourEditorProps } from '@/routes/hours/HourEditor.types'
import { isUserRoleAllowed } from '@/routes/utils'
import { Suspense } from 'react'
import { useFetcher } from 'react-router-dom'
import { Await, useLoaderData } from 'react-router-typesafe'

const HourEditor = (props: HourEditorProps) => {
  const { creating } = props

  const {
    title,
    hour,
    client,
    getClients,
    getCentriCosto,
    getPiattaforme,
    getTasks,
    getEmployees,
    getUserInfo,
    defaultCRUDAllowedRoles,
  } = useLoaderData<typeof hourEditorRouteLoader>()

  const fetcher = useFetcher()
  return (
    <>
      <Suspense fallback={<LoadingPanel />}>
        <Await resolve={Promise.all([getClients, getCentriCosto, getPiattaforme, getTasks, getEmployees, getUserInfo])}>
          {([clients, centriCosto, piattaforme, tasks, employees, userInfo]) => {
            const isAdministrator = isUserRoleAllowed(userInfo?.roles, [Roles.GlobalAdministrator, Roles.Administrator])
            const isOrganizer = userInfo?.roles?.hasRole(Roles.Organizer) === true
            const isOwnHour = userInfo?.email === hour.impiegato?.email
            const canEditByStandardRoles =
              isUserRoleAllowed(userInfo?.roles, defaultCRUDAllowedRoles) && (!isOrganizer || isAdministrator)
            const canEditOwnHourAsOrganizer = isOrganizer && isOwnHour

            return (
              <>
                <h2>{title}</h2>
                <div id="editor-hour-container" className={`dx-card responsive-paddings`}>
                  <fetcher.Form>
                    <HourEditorForm
                      creating={creating}
                      hour={hour}
                      client={client}
                      clients={clients.data.value}
                      centriCosto={centriCosto.data.value}
                      piattaforme={piattaforme.data.value}
                      tasks={tasks.data.value}
                      impiegati={employees.data.value}
                      userInfo={userInfo}
                      isRoleAllowed={canEditByStandardRoles || canEditOwnHourAsOrganizer}
                      fetcher={fetcher}
                    />
                  </fetcher.Form>
                </div>
              </>
            )
          }}
        </Await>
      </Suspense>
    </>
  )
}

export default HourEditor
